import React, { useState } from "react";
import { Form, Layout, Row, Col } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import Spacer from "../../../components/layouts/Spacer";
import FloatingFormActions from "../../../components/forms/FloatingFormActions";
import { EmployeesSelect } from "../../../components/forms/AutoCompleteFormItem";
import { DatePickerItem } from "../../../components/forms/FormItems";
import CheckBoxItem from "../../../components/forms/CheckBoxItem";
import moment from "moment";
import RestrictedContext from "../../../components/util/RestrictedContext";
import { usePermission } from "../../../hooks/accessControl";
import TransferHouseVisitsWrapper from "./TransferHouseVisits.style";
import FormHeader from "../../../components/forms/FormHeader";
import Surface from "../../../components/layouts/Surface";
import { FormattedMessage } from "react-intl";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import { transferHouseVisits, loadPage } from "../employeeHouseVisitsSlice";
import { useLocation } from "react-router-dom";

const TransferHouseVisits = (props) => {
  const { hide, activeEmployee, branchId } = props;
  const [form] = Form.useForm();
  const intl = useIntl();
  const dispatch = useDispatch();
  const location = useLocation();
  const [values, setValues] = useState({});

  const saveLoading = useSelector(
    (state) => state.pendingActions["houseVisits/updateSettings"]
  );

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    //pop error notification
  };

  const onFinish = async () => {
    const isAdmin = location.pathname.includes("admin");
    const params = {
      employeeId: activeEmployee.id,
      assigned_employee_id: values.assigned_employee_id,
      branchId,
      admin: isAdmin,
      from: moment(values.assigned_from_date).startOf("day").format(),
      to: values.assigned_all
        ? null
        : moment(values.assigned_to_date).endOf("day").format(),
    };
    const action = await dispatch(transferHouseVisits(params));
    if (!action.error) {
      hide();
      dispatch(loadPage());
    }
  };

  const onValuesChange = (changedValues, allValues) => {
    setValues(allValues);
  };

  const professionalFilter = {
    $and: [
      {
        $or: [
          { professional_role_id: 1 },
          { professional_role_id: 2 },
          { professional_role_id: 3 },
          { professional_role_id: 4 },
          { controller: true },
        ],
      },
      { $or: [{ status: 1 }, { status: 3 }] },
    ],
  };

  const disabledDate = (current) => {
    return (
      current && current < moment(values.assigned_from_date).startOf("day")
    );
  };
  const dateFormat = "DD/MM/YY";

  const hasPermission = usePermission(branchId, "employees", "editor");
  return (
    <Layout>
      <TransferHouseVisitsWrapper>
        <RestrictedContext.Provider
          value={{ hasWritePermission: hasPermission }}
        >
          <Form
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
            onValuesChange={onValuesChange}
            form={form}
            className="formBody"
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Surface>
                <FormHeader
                  title={
                    <FormattedMessage id="app.house_visits.transfer_house_visits" />
                  }
                />
                <Row>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                    <ResponsiveItemsWrapper>
                      <div style={{ flex: 1 }}>
                        <EmployeesSelect
                          name="assigned_employee_id"
                          category="house_visits"
                          waitForFetch={!branchId}
                          extraParams={{
                            scopePrefix: `branches/${branchId}/`,
                            filter: professionalFilter,
                          }}
                          proffesional={true}
                          required={true}
                        />
                      </div>
                      <Spacer horizontal={true} />
                      <div style={{ flex: 1 }} />
                    </ResponsiveItemsWrapper>

                    <ResponsiveItemsWrapper>
                      <div style={{ flex: 1 }}>
                        <DatePickerItem
                          name="assigned_from_date"
                          category="house_visits"
                          format={dateFormat}
                          required={true}
                        />
                      </div>
                      <Spacer horizontal={true} />
                      <div style={{ flex: 1 }}>
                        {!values.assigned_all && (
                          <DatePickerItem
                            name="assigned_to_date"
                            category="house_visits"
                            format={dateFormat}
                            disabled={
                              values.assigned_all || !values.assigned_from_date
                            }
                            required={true}
                            disabledDate={disabledDate}
                          />
                        )}
                      </div>
                    </ResponsiveItemsWrapper>
                    <ResponsiveItemsWrapper>
                      <div style={{ flex: 1 }}>
                        <CheckBoxItem
                          name="assigned_all"
                          category="house_visits"
                        />
                      </div>
                      <Spacer horizontal={true} />
                      <div style={{ flex: 1 }} />
                    </ResponsiveItemsWrapper>
                  </Col>
                </Row>
              </Surface>
              <Spacer vertical={true} />
            </div>
            <Spacer vertical={true} extra={true} />
            <FloatingFormActions
              resource={"patients"}
              action={"editor"}
              hideDelete={true}
              hideDecline={true}
              saveLoading={saveLoading}
              saveText={intl.formatMessage({
                id: "app.actions.saveChanges",
              })}
              show={
                values.assigned_employee_id &&
                (values.assigned_all ||
                  (values.assigned_from_date && values.assigned_to_date))
              }
            />
          </Form>
        </RestrictedContext.Provider>
      </TransferHouseVisitsWrapper>
    </Layout>
  );
};

export default TransferHouseVisits;
